import { cloneElement, Children } from 'react';
import PropTypes from 'prop-types';

import { Wrapper, InnerWrapper } from './index.styles';

export default function Tabs({ children, variant }) {
  return (
    <Wrapper>
      <InnerWrapper direction="row" gap={variant === 'filled' ? 8 : 0}>
        {Children.map(children, (child) => cloneElement(child, { variant }))}
      </InnerWrapper>
    </Wrapper>
  );
}

Tabs.propTypes = {
  /**
   * Tabs content.
   */
  children: PropTypes.node,
  /**
   * Tabs variant.
   */
  variant: PropTypes.oneOf(['filled', 'line']),
};
